import axios from "axios";

const LeaveRequestService = {
  // All leave requests with one status: PENDING | APPROVED | REJECTED
  async getByStatus(status) {
    try {
      const url = `/LeaveApprovels/GetAllRequestLeaveList?p_leaveStatus=${encodeURIComponent(status)}`;
      const response = await axios.get(url);
      console.log(`[LeaveRequest] getByStatus(${status}) response:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`[LeaveRequest] Error fetching ${status} requests:`, error);
      throw error;
    }
  },

  // kind: "APPROVE" | "REJECT"  (same params as DGES AcceptLeave / RejectLeave)
  async decide(kind, { formId, formNo, userId, reason }) {
    try {
      const route = { APPROVE: "LeaveApprovels", REJECT: "LeaveReject", CANCEL: "LeaveCancelation" }[kind];
      const params = new URLSearchParams({ p_leaveFormId: formId, p_formNo: formNo, P_UID: userId });
      if (kind !== "CANCEL") params.set("p_reason", reason || ""); // cancel takes no reason
      const response = await axios.post(`/LeaveApprovels/${route}?${params.toString()}`);
      console.log(`[LeaveRequest] ${kind} response:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`[LeaveRequest] Error on ${kind}:`, error);
      throw error;
    }
  },

  // Every request of one employee (used for the duplicate checks)
  async getByEmployee(serviceNo) {
    try {
      const response = await axios.get(
        `/LeaveApprovels/GetLeaveListByUserId?p_empServiceNo=${encodeURIComponent(serviceNo)}`
      );
      console.log("[LeaveRequest] getByEmployee response:", response.data);
      return response.data;
    } catch (error) {
      console.error("[LeaveRequest] Error fetching employee leaves:", error);
      throw error;
    }
  },

  // Dates must be YYYY/MM/DD. The attachment (base64 data-URL) goes in the body.
  async submit(p) {
    try {
      const params = new URLSearchParams({
        p_empServiceNo: p.empServiceNo,
        p_formNo: p.formNo,
        p_leaveType: p.leaveType,
        p_fromDate: p.fromDate,
        p_toDate: p.toDate,
        p_isHalfDay: p.isHalfDay,
        p_HalfDayType: p.halfDayType || "",
        p_reason: p.reason,
        p_contactNo: p.contactNo,
        P_UID: p.userId,
      });
      const response = await axios.get(`/LeaveApprovels/RequsetLeave?${params.toString()}`, {
        p_attachmentPath: p.attachmentPath || "",
      });
      console.log("[LeaveRequest] submit response:", response.data);
      return response.data;
    } catch (error) {
      console.error("[LeaveRequest] Error submitting request:", error);
      throw error;
    }
  },
};

export default LeaveRequestService;